import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
import Button from '../button/button';
import Tooltip from '../tooltip/tooltip';
import { dataHooks } from './constants';
var BaseModalFooter = /*#__PURE__*/function (_React$PureComponent) {
  function BaseModalFooter() {
    _classCallCheck(this, BaseModalFooter);
    return _callSuper(this, BaseModalFooter, arguments);
  }
  _inherits(BaseModalFooter, _React$PureComponent);
  return _createClass(BaseModalFooter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        sideActions = _this$props.sideActions,
        primaryButtonText = _this$props.primaryButtonText,
        primaryButtonOnClick = _this$props.primaryButtonOnClick,
        primaryButtonTooltipContent = _this$props.primaryButtonTooltipContent,
        primaryButtonProps = _this$props.primaryButtonProps,
        secondaryButtonText = _this$props.secondaryButtonText,
        secondaryButtonOnClick = _this$props.secondaryButtonOnClick,
        secondaryButtonProps = _this$props.secondaryButtonProps;
      if (!sideActions && !secondaryButtonText && !primaryButtonText) {
        return null;
      }
      var primaryButton;
      if (primaryButtonText) {
        primaryButton = /*#__PURE__*/React.createElement(Button, _extends({
          key: "primary",
          className: "control-base-modal-btn btn-confirm-primary btn-md",
          onClick: primaryButtonOnClick,
          dataHook: dataHooks.primaryButton
        }, primaryButtonProps), primaryButtonText);
        if (primaryButtonTooltipContent) {
          primaryButton = /*#__PURE__*/React.createElement(Tooltip, {
            dataHook: dataHooks.primaryButtonTooltip,
            content: primaryButtonTooltipContent
          }, primaryButton);
        }
      }
      return /*#__PURE__*/React.createElement("div", {
        className: classNames('control-base-modal-footer', className)
      }, sideActions && /*#__PURE__*/React.createElement("div", {
        className: "control-base-modal-side-actions",
        "data-hook": dataHooks.sideActions
      }, sideActions), secondaryButtonText && /*#__PURE__*/React.createElement(Button, _extends({
        className: "control-base-modal-btn btn-confirm-secondary btn-md",
        onClick: secondaryButtonOnClick,
        dataHook: dataHooks.secondaryButton
      }, secondaryButtonProps), secondaryButtonText), primaryButton);
    }
  }]);
}(React.PureComponent);
BaseModalFooter.displayName = displayNames.BASE_MODAL_FOOTER;
BaseModalFooter.propTypes = {
  /** A css class to be applied to the component's root element */
  className: PropTypes.string,
  /** side actions node, to be rendered as the first element on the same row as the action buttons */
  sideActions: PropTypes.node,
  /** a text for the primary action button */
  primaryButtonText: PropTypes.string,
  /** Passed to the primary action button as props without any filter / mutation */
  primaryButtonProps: PropTypes.object,
  /** callback for when the secondary action button is clicked */
  primaryButtonOnClick: PropTypes.func,
  /** a text for the secondary action button */
  secondaryButtonText: PropTypes.string,
  /** Passed to the secondary button as props without any filter / mutation */
  secondaryButtonProps: PropTypes.object,
  /** callback for when the secondary action button is clicked */
  secondaryButtonOnClick: PropTypes.func
};
BaseModalFooter.defaultProps = {};
export default compose(BaseModalFooter);